define('lib/backbone/Backbone.PodioRouter',['require','underscore','backbone','backbone-super','lib/Podio.Router'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  require('backbone-super');

  var router = require('lib/Podio.Router');

  var PodioRouter = Backbone.Router.extend({
    ENABLE_LOGGING: false,
    constructor: function(options) {
      this.propOptions = ['controller'];

      this._configure(options || {});

      Backbone.Router.prototype.constructor.apply(this, _.toArray(arguments));
    },

    navigate : function (fragment, options) {
      var func = this.useHistoryAPI ? router.goToRoute : router.goToHashRoute;

      if (!options) {
        options = {};
      }

      func(fragment, '', options.silent, options.handlerOptions);
    },

    _configure : function(options) {

      for (var i = 0, l = this.propOptions.length; i < l; i++) {
        var attr = this.propOptions[i];
        if (options[attr]) {
          this[attr] = options[attr];
        }
      }

      this.options = options;
    },

    _bindRoutes : function () {
      var routes = [];
      var func = this.useHistoryAPI ? router.addRoute : router.addHashRoute;

      if (this.ENABLE_LOGGING) {
        router.enableLogging();
      }

      if ( !this.routes ) {
        return;
      }

      if( !('waitUntilDomReady' in this) ) {
        this.waitUntilDomReady = true;
      }

      Object.keys(this.routes).forEach(function (path) {
        var route = this.routes[path];
        var callback;
        var options = {
          waitUntilDomReady : this.waitUntilDomReady
        };

        if (_.isString(route)) {
          callback = this[route];
        } else if (_.isObject(route)) {
          callback = this[route['action']];
          _.extend(options, route);
        }

        func(path, _.bind(callback, this), options);
      }.bind(this));

      router.onParsingStart.add(_.bind(this.onParsingStart, this));
    },

    onParsingStart: function() {
      if (_.isFunction(this.beforeNavigate)) {
        this.beforeNavigate();
      }
    },

    dispose: function() {
      var func = this.useHistoryAPI ? router.removeRoute : router.removeHashRoute;

      if (!this.routes) {
        return;
      }

      // unbind routes
      _.each(this.routes, function(value, path) {
        func(path);
      });

      if (this.ENABLE_LOGGING) {
        router.disableLogging();
      }

      router.onParsingStart.remove(this.onParsingStart);
    }
  });

  return PodioRouter;

});

